import { Injectable } from "@angular/core";
import { HoldingService } from "../http/business/holding/holding.service";

@Injectable({
  providedIn: "root"
})
export class CIDService {
  isOwner: boolean;
  constructor(private holdingService: HoldingService) {
    this.checkOwner();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
    });
  }

  setCID(data: string) {
    if (localStorage.getItem("companyCode") && this.isOwner) {
      localStorage.setItem("companyCode", data);
      localStorage.removeItem("branchCode");
      localStorage.removeItem("branchName");
    }

    if (!localStorage.getItem("companyCode")) {
      localStorage.setItem("companyCode", data);
      localStorage.removeItem("branchCode");
      localStorage.removeItem("branchName");
    }
  }

  setBrnachRoleName(branch: string, role: string) {
    localStorage.removeItem("branchName");
    localStorage.removeItem("roleName");
    localStorage.setItem("branchName", branch);
    localStorage.setItem("roleName", role);
  }
  getBrnachRoleName() {
    if (localStorage.getItem("branchName") && localStorage.getItem("roleName"))
      return localStorage.getItem("branchName") + ' - ' + localStorage.getItem("roleName")
    else
      return null
  }

  getCID() {
    return localStorage.getItem("companyCode");
  }

  removeCID() {
    localStorage.removeItem("companyCode");
  }

}
